"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require("react-router");

var _Button = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Button");

var _Button2 = _interopRequireDefault(_Button);

var _Checkbox = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Checkbox");

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _EpicSubscriptionSubscribe = require("./EpicSubscriptionSubscribe.scss");

var _EpicSubscriptionSubscribe2 = _interopRequireDefault(_EpicSubscriptionSubscribe);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EpicSubscriptionSubscribe = function (_React$Component) {
  (0, _inherits3.default)(EpicSubscriptionSubscribe, _React$Component);

  function EpicSubscriptionSubscribe(props) {
    (0, _classCallCheck3.default)(this, EpicSubscriptionSubscribe);

    var _this = (0, _possibleConstructorReturn3.default)(this, (EpicSubscriptionSubscribe.__proto__ || (0, _getPrototypeOf2.default)(EpicSubscriptionSubscribe)).call(this, props));

    _this.handleCheck = _this.handleCheck.bind(_this);

    _this.state = {
      checked: false
    };
    return _this;
  }

  (0, _createClass3.default)(EpicSubscriptionSubscribe, [{
    key: "handleCheck",
    value: function handleCheck(ev) {
      var currentTarget = ev.currentTarget;
      var checked = currentTarget.checked;


      this.setState({ checked: checked });
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          subscribeToUnrealUnlimited = _props.subscribeToUnrealUnlimited,
          subscribing = _props.subscribing,
          subscriptionError = _props.subscriptionError;
      var checked = this.state.checked;


      return _react2.default.createElement(
        "div",
        { className: _EpicSubscriptionSubscribe2.default.wrap },
        _react2.default.createElement(
          "p",
          null,
          "Since you have an Unreal Engine license, we can set you up with unlimited access."
        ),
        _react2.default.createElement(
          "label",
          { className: _EpicSubscriptionSubscribe2.default.checkboxLabel },
          _react2.default.createElement(_Checkbox2.default, { name: "eula", checked: checked, onChange: this.handleCheck }),
          _react2.default.createElement(
            "span",
            null,
            "Megascans access is licensed for Unreal Engine only. You agree that Megascans shall be treated as UE-Only Content under the Unreal Engine End User License Agreement that you have accepted under your Epic Games account."
          )
        ),
        _react2.default.createElement(_Button2.default, {
          loading: subscribing,
          className: _EpicSubscriptionSubscribe2.default.button,
          disabled: !checked,
          small: true,
          mode: "secondary",
          label: "Get Unlimited Access",
          onClick: subscribeToUnrealUnlimited
        }),
        subscriptionError ? _react2.default.createElement(
          "p",
          { className: _EpicSubscriptionSubscribe2.default.error },
          "Something went wrong while creating your unlimited access. Please try again in a short while or",
          " ",
          _react2.default.createElement(
            _reactRouter.Link,
            {
              to: "mailto:support@quixel.se",
              target: "_blank",
              rel: "noopener noreferrer"
            },
            "Contact Support."
          )
        ) : null
      );
    }
  }]);
  return EpicSubscriptionSubscribe;
}(_react2.default.Component);

exports.default = EpicSubscriptionSubscribe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/EpicSubscriptionSubscribe.jsx
// module id = 2628
// module chunks = 0